export default "__VITE_ASSET__DwjzyCOV__"